import { ROUTES_HANDLE_PAYMENT } from '@/constants/routes';

export default {
    path: '/handle-payment',
    name: ROUTES_HANDLE_PAYMENT,
    component: () => import(/*webpackChunkName: 'handle-stripe-payment'*/ '@/views/payment/HandleStripePayment.vue')
};
